// src/mappers/sales/quotation/createQuotationMapper.ts

export const createQuotationMapper = (
    form: any
) => {

    return {

        customerId:
            form.customer?.id ?? null,

        sellerId:
            form.seller?.id ?? null,

        branchId:
            form.branch?.id ?? null,

        expirationDate:
            form.expirationDate,

        notes:
            form.notes ?? '',

        // ==========================
        // 🔹 Condición de pago / crédito
        // ==========================

        paymentConditionId:
            form.paymentCondition?.id ?? null,

        termId:
            form.paymentCondition?.termId ?? null,

        creditDays:
            form.paymentCondition?.creditDays ?? null,

        creditMonths:
            form.paymentCondition?.creditMonths ?? null,

        creditYears:
            form.paymentCondition?.creditYears ?? null,

        creditDueDate:
            form.paymentCondition?.creditDueDate ?? null,

    };

};